import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { StateType } from "../../../utils/types";
import { getUserById, editUser } from "../../../redux/educator/actions";
import { selectUser } from "../../../redux/educator/selector";

const mapStateToProps = (state: StateType) => ({
  user: selectUser(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getUserById,
      editUser,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
